import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import { Container, Box } from '@mui/material';
import LoadingSpinner from './Components/Elements/LoadingSpinner';
import { defaultTheme } from './Config/Theme';
import { useAuth } from './Contexts/AuthProvider';
import AppShell from './layouts/AppShell';
import IncidentListPage from './Pages/IncidentListPage';
import CreateIncidentPage from './Pages/CreateIncidentPage';
import IncidentDashboardPage from './Pages/IncidentDashboardPage';
import HeadcounterMainPage from './Pages/HeadcounterMainPage';
import MissingUnaccountedPage from './Pages/MissingUnaccountedPage';
import ReviewSubmitPage from './Pages/ReviewSubmitPage';
import RosterViewSelectionPage from './Pages/RosterViewSelectionPage';
import ReportsPage from './Pages/ReportsPage';
import IncidentReportPage from './Pages/IncidentReportPage';
import SettingsPage from './Pages/SettingsPage';
import SettingsLocationsPage from './Pages/SettingsLocationsPage';
import AccessDeniedPage from './Pages/AccessDeniedPage';
import FacilityMapPage from './Pages/FacilityMapPage';
import IncidentTeamPage from './Pages/IncidentTeamPage';
import EditIncidentPage from './Pages/EditIncidentPage';
import HelpLandingPage from './Pages/HelpLandingPage';
import HelpTopicPage from './Pages/HelpTopicPage';

export default function App() {
    const { initialized } = useAuth();

    if (!initialized) {
        return (
            <ThemeProvider theme={defaultTheme}>
                <Container maxWidth={false} sx={{ mt: 6, mb: 6, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box>
                        <LoadingSpinner text="Initializing application.  Please wait..." />
                    </Box>
                </Container>
            </ThemeProvider>
        );
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Routes>
                <Route element={<AppShell />}>
                    <Route path="/" element={<IncidentListPage />} />
                    <Route path="/incidents/new" element={<CreateIncidentPage />} />
                    <Route path="/incidents/:incidentId/incidentdashboard" element={<IncidentDashboardPage />} />
                    <Route path="/incidents/:incidentId/edit" element={<EditIncidentPage />} />
                    <Route path="/incidents/:incidentId/unaccounted" element={<MissingUnaccountedPage />} />
                    <Route path="/incidents/:incidentId/views" element={<RosterViewSelectionPage />} />
                    <Route path="/incidents/:incidentId/headcount" element={<HeadcounterMainPage />} />
                    <Route path="/incidents/:incidentId/review" element={<ReviewSubmitPage />} />
                    <Route path="/incidents/:incidentId/facility-map" element={<FacilityMapPage />} />                        <Route path="/incidents/:incidentId/team" element={<IncidentTeamPage />} />                    <Route path="/incidents/:incidentId/report" element={<IncidentReportPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/settings/locations" element={<SettingsLocationsPage />} />
                    <Route path="/help" element={<HelpLandingPage />} />
                    <Route path="/help/:topicSlug" element={<HelpTopicPage />} />
                    <Route path="/access-denied" element={<AccessDeniedPage />} />
                </Route>
            </Routes>
        </ThemeProvider>
    );
}
